import { parseAppMarketQueryParam } from '../../../../ui/shared/util/tpa';
import { AppMarketQueryRoutes } from '../../../../ui/shared/util/tpa/parseAppMarketQueryParam';
import { getQueryParams } from '../../../../utils';

type IntentInstallTestingParams = {
  isSilent: boolean;
  pendingApps: string[];
};

const defaultIntentInstallTestingParams: IntentInstallTestingParams = {
  isSilent: false,
  pendingApps: [],
};

// needed for easier E2E testing
export function getIntentInstallTestParams(): IntentInstallTestingParams {
  const queryParams = getQueryParams();

  const debug = queryParams.debug;

  const isSled = /yes_this_is_sled/.test(window.document.cookie);

  const isDebug = debug && ['all', '1'].includes(debug);

  if (!isSled && !isDebug) {
    return defaultIntentInstallTestingParams;
  }

  const testParams = queryParams.sledPlatformInstallParams;

  if (!testParams) {
    return defaultIntentInstallTestingParams;
  }

  try {
    const { isSilent, pendingApps } = JSON.parse(atob(testParams));
    return { isSilent, pendingApps };
  } catch {
    return defaultIntentInstallTestingParams;
  }
}

const BLACKLISTED_INTENT_INSTALL_ROUTES = new Set([
  AppMarketQueryRoutes.TEST_APP,
  AppMarketQueryRoutes.MANAGE_APPS,
]);

const shouldIgnoreIntentApp = (
  params: ReturnType<typeof parseAppMarketQueryParam>,
): boolean => {
  if (params?.shouldEditorInstall === false) {
    return true;
  }

  if (params?.route && BLACKLISTED_INTENT_INSTALL_ROUTES.has(params.route)) {
    return true;
  }

  return false;
};

export function getIntentAppInfoFromQueryParams() {
  const queryParams = getQueryParams();
  const appMarketQS = queryParams.appMarketParams;

  if (!appMarketQS) {
    return;
  }

  try {
    const parsedParams = parseAppMarketQueryParam(appMarketQS);

    if (shouldIgnoreIntentApp(parsedParams)) {
      return;
    }

    return {
      appDefId: parsedParams?.appDefId,
      version: parsedParams?.version,
      shouldEditorInstall: parsedParams?.shouldEditorInstall ?? true,
    };
  } catch {
    return;
  }
}
